import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  StyledBoxAvatar,
  StyledAvatar,
  StyledIcon,
  StyledGroupIcon,
  StyledElements,
  StyledName,
  StyledJob,
  WrapperAvatarPerson
} from './style';

import { Phone, Envios, Chat } from '../../../../assets/images/index';
import TooltipBasic from '../Tooltip/TooltipBasic';
import Tooltip from '../Tooltip/Tooltip';
import { AVATAR_MEDIUM } from '../../../utils/crops';

const AvatarModule = ({
  className,
  person,
  lastname,
  job,
  email,
  phone,
  userId,
  avatarPhoto
}) => (
  <StyledBoxAvatar className={className}>
    <WrapperAvatarPerson>
      <Link
        to={userId !== '99999999' ? `/perfil/${userId}/mi_perfil` : '#'}
        title={userId !== '99999999' ? `ver perfil de ${person}` : undefined}
      >
        <StyledAvatar
          name={person}
          lastname={lastname}
          userId={userId}
          crop={AVATAR_MEDIUM}
          avatarPhoto={avatarPhoto}
        />
      </Link>
    </WrapperAvatarPerson>
    <Link to={userId !== '99999999' ? `/perfil/${userId}/mi_perfil` : '#'}>
      <StyledName>{person}</StyledName>
    </Link>
    <StyledJob>{job}</StyledJob>
    <StyledGroupIcon>
      {phone && (
        <StyledElements>
          <Tooltip>
            <StyledIcon size="m" svg={Phone} hover />
            <TooltipBasic>
              <p>{phone}</p>
            </TooltipBasic>
          </Tooltip>
        </StyledElements>
      )}
      <StyledElements>
        <a
          href={
            email
              ? `https://outlook.office.com/owa/?path=/mail/action/compose&to=${email}`
              : 'https://outlook.office.com/mail/inbox'
          }
          title={`Enviar email a ${person}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <StyledIcon size="m" svg={Envios} hover />
        </a>
      </StyledElements>
      <StyledElements>
        <a
          href={
            email
              ? `https://teams.microsoft.com/l/chat/0/0?users=${email}`
              : 'https://teams.microsoft.com/'
          }
          title="Iniciar chat"
          target="_blank"
          rel="noopener noreferrer"
        >
          <StyledIcon size="m" svg={Chat} hover />
        </a>
      </StyledElements>
    </StyledGroupIcon>
  </StyledBoxAvatar>
);

AvatarModule.propTypes = {
  className: PropTypes.string,
  person: PropTypes.string,
  lastname: PropTypes.string,
  job: PropTypes.string,
  email: PropTypes.string,
  userId: PropTypes.string,
  avatarPhoto: PropTypes.bool
};

export default AvatarModule;
